import { type FC } from 'react';
import { useSelector } from 'react-redux';

import { ChangesStatus } from '@editor2/types/changesStatus';
import { type RootState } from '@editor2/reducers/root';
import { pageGroupToPageGroupProperties } from '@editor2/mappers/pageGroup';
import ChangesHeader from './common/ChangesHeader';
import AttributesChanges from './common/AttributesChanges';
import ChildrenChanges from './common/ChildrenChanges';

interface Props {
	courseId: number;
	pageGroupId: string;
}

const PageGroupChanges: FC<Props> = (props) => {
	const { pageGroupId, courseId } = props;

	const { changes, page_groups, chapters, initialCourse } = useSelector(
		(state: RootState) => state.courses[courseId]
	);

	const changesStatuses = changes.page_groups[pageGroupId];
	const currentPageGroup = page_groups.entities[pageGroupId];
	const initialPageGroup = initialCourse.page_groups.entities[pageGroupId];

	const getPageGroupName = (pageGroupId: string) => {
		const entity =
			page_groups.entities[pageGroupId] || initialCourse.page_groups.entities[pageGroupId];
		return entity.name;
	};

	const getChapterByPageGroupId = (pageGroupId: string) => {
		return Object.keys(chapters.entities).find((key) =>
			chapters.entities[key].page_groups?.includes(pageGroupId)
		);
	};

	const getPageGroupLink = () => {
		const chapterId = getChapterByPageGroupId(pageGroupId);
		return `/courses/${courseId}/chapters/${chapterId}/page_groups/${pageGroupId}`;
	};

	return (
		<div className="changeBlock">
			<ChangesHeader
				changesStatuses={changesStatuses}
				headerTitle={`PageGroup ${getPageGroupName(pageGroupId)}`}
				link={changesStatuses.includes(ChangesStatus.Deleted) ? null : getPageGroupLink()}
			/>

			{changesStatuses.includes(ChangesStatus.Modified) &&
				!changesStatuses.includes(ChangesStatus.New) && (
					<AttributesChanges
						currentEntity={currentPageGroup}
						initialEntity={initialPageGroup}
						mapper={pageGroupToPageGroupProperties}
					/>
				)}
			{changesStatuses.includes(ChangesStatus.ChildrenReorder) && (
				<ChildrenChanges
					currentIds={currentPageGroup.pages}
					initialIds={initialPageGroup?.pages || []}
					changesEntity={changes.pages}
					title="page"
				/>
			)}
		</div>
	);
};

export default PageGroupChanges;
